import React from 'react';
import PropTypes from 'prop-types';
import Tabs from 'tailwind-components/Tabs/Tabs';
import { cn } from 'lib/utils';

export default function ContentLibraryCategoryTabs({
  className,
  categories,
  activeCategory,
  onCategoryChange
}) {
  if (categories.length === 0) return null;

  return (
    <Tabs
      tabs={categories}
      activeTabId={activeCategory}
      onTabChange={id => onCategoryChange(id)}
      buttonClassName='font-medium'
      scrollButtons
      className={cn('max-lg:justify-between', className)}
    />
  );
}

ContentLibraryCategoryTabs.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeCategory: PropTypes.string.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  className: PropTypes.string
};
